<mat-card class="process-fullview-container">
  <h2>Detalhes do Processo - {{ process.numeroProcesso }}</h2>
  <mat-tab-group>
    <mat-tab label="Etapas">
      <app-process-steps [process]="process"></app-process-steps>
    </mat-tab>
    <mat-tab label="Equipe">
      <app-process-team [process]="process"></app-process-team>
    </mat-tab>
    <mat-tab label="Comunicação Interna">
      <app-process-communication [process]="process"></app-process-communication>
    </mat-tab>
    <mat-tab label="Documentação">
      <app-process-documentation [process]="process"></app-process-documentation>
    </mat-tab>
    <mat-tab label="Documentos de Arrecadação">
      <app-process-collection-documents [process]="process"></app-process-collection-documents>
    </mat-tab>
    <mat-tab label="Requerimento">
      <app-process-requirements [process]="process"></app-process-requirements>
    </mat-tab>
    <mat-tab label="Reincidências">
      <app-process-recurrences [process]="process"></app-process-recurrences>
    </mat-tab>
    <mat-tab label="Linha do Tempo">
      <app-process-timeline [process]="process"></app-process-timeline>
    </mat-tab>
    <mat-tab label="Visualizado por">
      <app-process-viewed-by [process]="process"></app-process-viewed-by>
    </mat-tab>
  </mat-tab-group>
</mat-card>